import getGroupsRequest from "./requests/get-groups-request";
import updateCompanyHashRequest from "./requests/update-company-hash-request";
import updateAllGroupHashRequest from "./requests/update-all-group-hash-request";
import createCompanyGroupRequest from "./requests/create-company-group-request";
import updateCompanyGroupRequest from "./requests/update-company-group-request";
import deleteCompanyGroupRequest from "./requests/delete-company-group-request";

const v2CompanyLinkRepository = {
    getGroups: getGroupsRequest,
    updateCompanyHash: updateCompanyHashRequest,
    updateAllGroupHash: updateAllGroupHashRequest,
    createCompanyGroup: createCompanyGroupRequest,
    updateCompanyGroup: updateCompanyGroupRequest,
    deleteCompanyGroup: deleteCompanyGroupRequest,
};

export default v2CompanyLinkRepository;